import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import toast from "react-hot-toast";

import NonVerifyEmailModal from "../../components/NonVerifyEmailModal";
import { SpinnerLoading } from "../../components/Loadings";
import { getPublicTenantbyId } from "../../Utility/ApiService";
import { LOGO } from "../../Utility/static";
import { takeSignInFlash } from "../../Utility/signInFlash";

export default function AuthLanding() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isSignInSelected, setIsSignInSelected] = useState(true);
  const [isErrorMsg, setIsErrorMsg] = useState();
  const [show, setShow] = useState(true);
  const [lastAuthMethod, setLastAuthMethod] = useState(null);

  const params = new URLSearchParams(typeof window !== "undefined" ? window.location.search.substring(1) : " ");

  const tenantId = params.get("tenantId") || "";

  // Show a sign-in rejection message saved before the Cognito logout redirect (one-shot).
  useEffect(() => {
    const flash = takeSignInFlash();
    if (flash) toast.error(flash);
  }, []);

  useEffect(() => {
    get_tenant();
    
    const getCookie = (name) => {
      const nameEQ = name + "=";
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(nameEQ)) {
          return decodeURIComponent(cookie.substring(nameEQ.length));
        }
      }
      return null;
    };

    const readAuthMethod = () => {
      const savedAuthMethod = getCookie("arrivo_last_auth_preference");
      if (savedAuthMethod) {
        setLastAuthMethod(savedAuthMethod);
      }
    };

    // Read immediately on mount
    readAuthMethod();
  }, [tenantId]);

  const get_tenant = async () => {
    if (tenantId) {
      setIsSignInSelected(false);
      await getPublicTenantbyId(tenantId)
        .then((data) => {
          if (data) {
            if (data?.cognito_user_id !== null) {
              setIsErrorMsg("Tenant is already registered with this invitation ID");
            }
          } else {
            setIsErrorMsg("Tenant does not exist with this invitation ID");
          }
        })
        .catch((err) => {
          console.log("get_tenant error", err);
          setIsErrorMsg("Something went wrong");
        });
    } else {
      setIsErrorMsg("Oops! - Only Invited Tenants are able to sign up or sign in to this portal");
    }
  };

  const onSocialLogin = async (type) => {
    try {
      if (isErrorMsg && !isSignInSelected) {
        return toast.error(isErrorMsg);
      }
      if (isSignInSelected) {
        localStorage.setItem("signInSelected", "0");
      } else {
        localStorage.setItem("signInSelected", "1");
      }
      await Auth.federatedSignIn({ provider: type });
    } catch (error) {
      console.log("federatedSignIn err", error);
      toast.error("Singin failed");
    }
  };

  const goToScreen = (e) => {
    e.preventDefault();
    // F5: same guard as onSocialLogin above — the email path must not bypass what the Google path blocks.
    if (isErrorMsg && !isSignInSelected) {
      return toast.error(isErrorMsg);
    }
    if (isSignInSelected) {
      navigate(tenantId ? `/SignUpSignIn?tenantId=${tenantId}` : "/SignUpSignIn/", {
        state: { isSignIn: true },
      });
    } else {
      navigate(tenantId ? `/SignUpSignIn?tenantId=${tenantId}` : "/SignUpSignIn/", {
        state: { isSignIn: false },
      });
    }
  };

  return (
    <div className="forms">
      <div id="layout-wrapper">
        {loading && (
          <div className="loadingSpinner">
            <SpinnerLoading />
          </div>
        )}

        <div className="errors"></div>
        {/* START SignIn / SignUp */}
        <div className="form-pages">
          <section className="sidebar align-items-center">
            <img src={LOGO} alt="" className="logo-img" />
          </section>
          {/* end sidebar */}
          <section className="content align-items-center justify-content-center">
            <div className="auth-form bg-white">
              {show ? (
                <>
                  <h2 className={`mb-3 text_wrap ${tenantId ? "text-center" : ""}`}>Welcome!</h2>
                  {!tenantId && (
                    <ul className="nav nav-pills tab-v1">
                      <li className="nav-item">
                        <button
                          onClick={() => setIsSignInSelected(!isSignInSelected)}
                          className={"nav-link " + (!isSignInSelected ? "active" : "")}
                        >
                          Sign Up
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          onClick={() => setIsSignInSelected(!isSignInSelected)}
                          className={"nav-link " + (isSignInSelected ? "active" : "")}
                        >
                          Sign In
                        </button>
                      </li>
                    </ul>
                  )}

                  <div className="auth-form-content">
                    <div className="initial-view">
                      {isSignInSelected && (
                        <div className="auth-button-wrapper">
                          <button
                            className="btn btn-primary apple-app  mb-4 w-100"
                            onClick={() => onSocialLogin("SignInWithApple")}
                          >
                            <img
                              src={require("../../assets/images/apple.svg").default}
                              alt=""
                              width={20}
                              className="me-2"
                            />
                            {isSignInSelected ? `Sign In with Apple` : "Sign Up with Apple"}
                          </button>
                          {isSignInSelected && lastAuthMethod === "apple" && (
                            <span className="auth-last-used-badge">Last used</span>
                          )}
                        </div>
                      )}
                      <div className="auth-button-wrapper">
                        <button className="btn btn-primary mb-4 w-100" onClick={() => onSocialLogin("Google")}>
                          <img
                            src={require("../../assets/images/google.svg").default}
                            alt=""
                            width={20}
                            className="me-2"
                          />
                          {isSignInSelected ? `Sign In with Google` : "Sign Up with Google"}
                        </button>
                        {isSignInSelected && lastAuthMethod === "google" && (
                          <span className="auth-last-used-badge">Last used</span>
                        )}
                      </div>
                      <div className="text-center mb-4 w-100">or</div>
                      <div className="auth-button-wrapper">
                        <a onClick={(e) => goToScreen(e)} className="btn btn-primary mb-4 w-100">
                          {isSignInSelected ? `Sign In with Email` : "Sign Up with Email"}
                        </a>
                        {isSignInSelected && lastAuthMethod === "email" && (
                          <span className="auth-last-used-badge">Last used</span>
                        )}
                      </div>
                    </div>
                    {/* end signin initial view */}
                    {isSignInSelected && (
                      <p className="text-center mb-0">
                        Don't have an account?{" "}
                        <a
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(tenantId ? `/SignUpSignIn?tenantId=${tenantId}` : "/SignUpSignIn/", {
                              state: { isSignIn: false },
                            });
                          }}
                        >
                          <strong className="text-link">Sign Up</strong>
                        </a>
                      </p>
                    )}
                    <p className="mb-0 text-center">
                      Already signed up, need to verify email?{" "}
                      <a href="#" className="fw-bold d-sm-inline d-block text-link" onClick={() => setShow(!show)}>
                        Click here
                      </a>
                    </p>
                  </div>
                </>
              ) : (
                <NonVerifyEmailModal
                  setLoading={setLoading}
                  goToLogin={() => {
                    setShow(true);
                    setIsSignInSelected(true);
                  }}
                />
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
